import React from 'react';
import ReportingClassesRegistrationsPage from '../components/ReportingClassesRegistrationsPage';

const ReportingClassesRegistrationsApp = (props) => (
  <ReportingClassesRegistrationsPage {...props} />
);

export default ReportingClassesRegistrationsApp;
